<template>
  <el-dialog
          :title="!dataForm.id ? '新增' : '修改'"
          :close-on-click-modal="false"
          :visible.sync="visible"
  style="text-align: left">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="150px">
      <el-form-item label="人员" prop="userid">
        <el-select clearable  reserve-keyword filterable remote :remote-method="searchChecker1"    v-model="dataForm.userid" placeholder="输入姓名" :loading="loading1">
          <el-option
                  v-for="item in approvers"
                  :key="item.id"
                  :label="item.xm"
                  :value="item.id">
            <span style="float: left">{{ item.xm }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.username }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="签订日期" prop="ldhtqdrq">
        <el-date-picker
                v-model="dataForm.ldhtqdrq"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="起始日期" prop="ldhtqsrq">
        <el-date-picker
                @change="changeqs"
                v-model="dataForm.ldhtqsrq"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="不固定期限" prop="isFixed">
        <el-select v-model="dataForm.isFixed" ref="isFxed" placeholder="请选择" @change="changeFixed()">
          <el-option
                  :key="0"
                  :label="'否'"
                  :value="0"></el-option>
            <el-option
                    :key="1"
                    :label="'是'"
                    :value="1"></el-option>

        </el-select>
      </el-form-item>
      <el-form-item label="合同期限(年)" prop="ldhtqx">
        <el-input v-model="dataForm.ldhtqx" :disabled="xqDisable" ref="ldhtqx"  clearable placeholder="合同期限"></el-input>
      </el-form-item>
      <el-form-item label="截止时间" prop="ldhtjzrq">
        <el-date-picker
                :disabled="jzrqDisable"
                v-model="dataForm.ldhtjzrq"
                ref="ldhtjzrq"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="工资" prop="ldhtgz">
        <el-input type="text" v-model="dataForm.ldhtgz" placeholder="备注"></el-input>
      </el-form-item>
      <el-form-item label="同步工资生效日期" prop="tbgzsxrq">
        <el-date-picker
                v-model="dataForm.tbgzsxrq"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="需补贴(月)" prop="xbty">
        <el-input type="text" v-model="dataForm.xbty" placeholder="备注"></el-input>
      </el-form-item>
      <el-form-item label="附件" prop="attach">
        <el-upload
                list-type="picture-card"
                :on-remove="handleRemove"
                :file-list="fileList"
                :http-request="httpRequest"
                :on-preview="handlePictureCardPreview" action="#">
          <i class="el-icon-plus"></i>
        </el-upload>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
          <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {

    data () {
      const validateNumber = (rule, value, callback) => {
      if(value){
        var patrn = /^\d+(\.\d+)?$/;
        if (!patrn.exec(value)) {
          callback(new Error('请填写数字'))
        } else {
          callback()
        }
      } else callback()
      }
      const validateNumber0 = (rule, value, callback) => {
        if (this.dataForm.isFixed == 0) {
          if (value) {
            var patrn = /^\d+(\.\d+)?$/;
            if (!patrn.exec(value)) {
              callback(new Error('请填写数字'))
            } else {
              callback()
              if (this.dataForm.ldhtqsrq) {

                var date2 = this.getDate(this.dataForm.ldhtqsrq);
                var date = new Date(date2);
                date.setMonth(date2.getMonth() + 12 * value)
                date.setDate(date2.getDate() - 1)
                console.log(date)
                var nowFormatDate = this.getNowFormatDate(date);
                this.dataForm.ldhtjzrq = nowFormatDate

              }

            }
          } else callback(new Error('请填写期限'))
        } else {
          callback()
          this.dataForm.ldhtjzrq = ''
        }
      }

      const validateJzrq = (rule, value, callback) => {
        if (this.dataForm.isFixed == 0) {
          if (value) {
            callback()
          } else callback(new Error('请选择截止日期'))
        } else {
          callback()
        }
      }
      return {
        form: {
          datils: [

          ],
        },
        visible: false,
        menuList: [],
        approvers:[],
        loading1:false,
        customerList:[],
        dataForm: {
          id: '',
          ldhtqdrq: '',
          ldhtqsrq: '',
          ldhtjzrq: '',
          ldhtqx: '',
          ldhtgz: '',
          tbgzsxrq: '',
          attach:'',
          userid:'',
          xbty:'',
          isFixed: 0
        },
        types: [],
        fileList:[],
        dialogVisible:false,
        dialogImageUrl:'',
        fileList2:[],

        uploadUrl:'',
        dataRule: {
          userid: [
            {required: true, message: '请填写卖方名称', trigger: 'blur'}
          ],
          ldhtqdrq:[
            {required: true, message: '请填写签订日期', trigger: 'blur'},
          ],
          ldhtqsrq:[
            {required: true, message: '请填写起始日期', trigger: 'blur'},
          ], isFixed:[
            {required: true, message: '请选择是否固定期限', trigger: 'blur'},
          ],
          ldhtgz:[
            {validator:validateNumber,trigger: 'blur'},
          ],
          xbty:[
            {validator:validateNumber,trigger: 'blur'},
          ],
          ldhtqx: [
            {validator:validateNumber0,trigger: 'blur'},
            {validator:validateNumber0,trigger: 'change'}
          ],
          ldhtjzrq: [
            {validator:validateJzrq,trigger: 'blur'},
          ]
        },
        jzrqDisable: false,
        xqDisable: false
      }
    },
    methods: {
      init (id) {
       if(!id) return
        this.visible = true
        this.$nextTick(() => {
          this.jzrqDisable = false
          this.xqDisable = false
          this.approvers=[]
          console.log('11111111111111111111')
          this.$refs['dataForm'].resetFields()
          this.fileList=[]
          var user = {id:id.userid,xm:id.xm}
          this.approvers.push(user)
          this.dataForm.userid =id.userid
        })

      },
      beforeAvatarUpload(file){
        return  true;
      },
      getNowFormatDate(date) {
        var seperator1 = "-";
        var year = date.getFullYear();
        this.year = year;
        console.log(this.year)
        var month = date.getMonth() + 1;
        this.month = month;
        console.log(this.month)
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate+" 00:00:00";
        return currentdate;
      },
      changeqs() {
        this.$refs.dataForm.validateField("ldhtqx")
      },
      changeFixed() {
        if(this.dataForm.isFixed == 0) {
          this.jzrqDisable = false
          this.xqDisable = false
        } else if(this.dataForm.isFixed == 1) {
          this.dataForm.ldhtqx =''
          this.dataForm.ldhtjzrq = ''
          this.jzrqDisable = true
          this.xqDisable = true
        }
      },
      searchChecker1(query) {
        console.log(query)
        if (query !== '') {
          this.loading1 = true;

          this.$request.get('/bjba/yhgl/findUserListByxm',{
            params: {
              xm:query
            }

          }).then(res => {
            this.loading1 =false
            this.approvers = res.data.data

          })
        } else {
          this.approvers = [];
        }
      },
      getDate(date) {
        date = date.substring(0,19);
        date = date.replace(/-/g,'/');
        var timestamp = new Date(date)
        return timestamp
      },
      httpRequest(data){
        let _that=this;
        let rd = new FileReader(); // 创建文件读取对象
        let file = data.file;
        let formData = new FormData();
        formData.append('file', file);
        this.$request({
          method: 'post',
          url: '/bjba/fileupload/upload',
          data:formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          }
        }).then(res => {
          console.log(res.data)
          this.fileList.push({url:res.data.url})
        })
      },
      handlePictureCardPreview(file) {
        this.dialogVisible = true
        this.dialogImageUrl = file.url
      },
      handleRemove(file, fileList) {
        this.fileList.splice(this.fileList.findIndex(e => e.uid === file.uid), 1)
        if (file.url && !this.dataForm.id) {
          this.$request({
            method: 'post',
            url: '/bjba/fileupload/delete',
            params:{url:file.url}
          }).then(res => {
            console.log(res.data)
          })
        }
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
                this.$http({
                  url: `/bjba/workContract/save`,
                  method: 'post',
                  data: {data:this.dataForm,urls:this.fileList.map(e=>e.url)}
                }).then(({data}) => {
                  if (data && data.code === 200) {
                    this.$message({
                      message: '操作成功',
                      type: 'success',
                      duration: 1500
                    })
                    this.visible = false
                    this.$emit('refreshDataList')
                  } else if(data && data.code === 500) {
                    this.$message({
                      message: data.message,
                      type: 'error',
                      duration: 1500
                    })
                  }
                })


          }
        })
      }
    }
  }
</script>
